const axios = require("axios");
const swal = require("sweetalert2");

const addonStore = {
  state: {
    addon_duration: null,
    code_exist: null,
  },
  mutations: {
    SET_ADDON_DURATION(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.addon_duration = val;
    },
    SET_CODE_EXIST(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.code_exist = val;
    },
  },
  actions: {
    setAddonDuration({ commit }, duration) {
      commit("SET_ADDON_DURATION", duration);
    },

    async validateCode({ commit }, criteria) {
      try {
        const response = await axios.post("/check-addon-code", {
          search: criteria,
        });

        if (response.data.code) {
          commit("SET_CODE_EXIST", true);
        } else {
          commit("SET_CODE_EXIST", false);
        }
      } catch (error) {
        swal.fire({
          type: "error",
          title: "Error",
          html: `<h5>${error.response.data.message}</h5><br/>`,
          showConfirmButton: true,
        });
      }
    },

    async submitAddNewAddonForm({ commit }, fields) {
      commit("SET_LOADING_SUBMIT_FORM", true, { root: true });
      try {
        const response = await axios({
          url: "/addons/new",
          method: "post",
          transformRequest(data) {
            const formData = new FormData();
            formData.append("code", data.allFields.code);
            formData.append("name", data.allFields.name);
            formData.append("locale_id", data.allFields.locale_id);
            formData.append("base_price", data.allFields.base_price);
            formData.append("nexus", data.allFields.nexus);
            formData.append("description", data.allFields.description);
            formData.append("duration", data.allFields.duration);
            formData.append(
              "eclipse_product",
              JSON.stringify(data.allFields.eclipse_product)
            );
            formData.append(
              "eclipse_product_name",
              JSON.stringify(data.allFields.eclipse_product_name)
            );
            formData.append(
              "product_implementation",
              JSON.stringify(data.allFields.product_implementation)
            );
            formData.append(
              "product_cycle_start",
              JSON.stringify(data.allFields.product_cycle_start)
            );
            formData.append(
              "product_cycle_end",
              JSON.stringify(data.allFields.product_cycle_end)
            );
            formData.append(
              "edist_cut",
              JSON.stringify(data.allFields.edist_cut)
            );
            formData.append("var_cut", JSON.stringify(data.allFields.var_cut));
            formData.append("ces_cut", JSON.stringify(data.allFields.ces_cut));

            return formData;
          },
          data: { allFields: fields },
        });

        if (response.status === 200) {
          swal.fire({
            type: "success",
            title: "Success",
            html: "<h5>New addon was created.</h5><br/>",
            showConfirmButton: false,
          });
          window.location.href = "/addons";
        } else {
          swal.fire({
            type: "error",
            title: "Oops...",
            html:
              "<h5>Something went wrong!</h5><br/>" +
              "<h5>Please refresh the page and try again.</h5><br/>",
            showConfirmButton: true,
          });
        }
      } catch (error) {
        swal.fire({
          type: "error",
          title: "Error",
          html: `<h5>${error.response.data.message}</h5><br/>`,
          showConfirmButton: true,
        });
      }
      commit("SET_LOADING_SUBMIT_FORM", false, { root: true });
    },
  },
};

export default addonStore;
